import type { ReactNode } from "react";
import {
  ListBoxSection as ReactAriaListBoxSection,
  type ListBoxSectionProps,
} from "react-aria-components";
import { cn } from "../../../utilities/tailwind";

export type ListBoxSectionProperties = ListBoxSectionProps<object> & {
  className?: string | undefined;
  children: ReactNode;
};
export const ListBoxSection = ({
  className = "",
  children,
  ...properties
}: ListBoxSectionProperties) => {
  const twClassname = cn("bg-white", className);

  return (
    <ReactAriaListBoxSection className={twClassname} {...properties}>
      {children}
    </ReactAriaListBoxSection>
  );
};
ListBoxSection.displayName = "InputComboBox.ListBoxSection";
